import React from 'react';

import Link from 'next/link';

import KittlKIcon from '@repo/ui/components/Icon/KittlKIcon';
import { themeStyle } from '@repo/ui/theming';

import { LogoSVG } from './LogoSVG';
import { SmallIconWrapper, StyledLink } from './styles';
import { defaultTheme } from './theme';
import { LogoProps, LogoThemeProps } from './types';

const LogoElement: React.FC<LogoProps & { theme: LogoThemeProps }> = (
  props
) => {
  if (props.small) {
    const _theme = {
      ...props.theme,
      logoColor: themeStyle.varInkMain,
      textColor: themeStyle.varInkBase,
    };

    return (
      <SmallIconWrapper
        data-testid={props.dataTestId}
        height="16px"
        logoColor={_theme.logoColor}
        width="16px"
        onClick={props.onClick}
      >
        <KittlKIcon
          height="11px"
          theme={{ color: _theme.textColor }}
          width="12px"
        />
      </SmallIconWrapper>
    );
  }
  return (
    <LogoSVG
      data-testid={props.dataTestId}
      height={props.height || '36px'}
      logoColor={props.theme.logoColor}
      width={props.width || '92px'}
      onClick={props.onClick}
    />
  );
};

const Logo: React.FC<LogoProps> = (props) => {
  const theme = { ...defaultTheme, ...props.theme };

  if (props.href) {
    return (
      <Link legacyBehavior passHref href={props.href}>
        <StyledLink aria-label="Kittl">
          <LogoElement {...props} theme={theme} />
        </StyledLink>
      </Link>
    );
  }

  if (props.onClick) {
    return (
      <StyledLink as="div">
        <LogoElement {...props} theme={theme} />
      </StyledLink>
    );
  }
  return <LogoElement {...props} theme={theme} />;
};

export default Logo;
